module.exports = __webpack_public_path__ + "img/student1.8be45746.png";